import NotificationsPage from "pages/NotificationsPage";
import React from "react";

const NotificationsRoute = () => <NotificationsPage />;

export default NotificationsRoute;
